'use client';

import noop from 'lodash/noop';
import React, { useState, createContext, useContext, useMemo } from 'react';

type AccordionProviderProps = {
  children: any;
  deafultOpen: boolean;
};

type AccoridionState = {
  open: boolean;
  setOpen: (arg: boolean) => void;
};

const AccordionContext = createContext<AccoridionState>({ open: false, setOpen: noop });

export function AccordionProvider({ children, deafultOpen }: AccordionProviderProps) {
  const [open, setOpen] = useState(deafultOpen);

  const values = useMemo(() => ({ open, setOpen }), [open]);

  return <AccordionContext.Provider value={values}>{children}</AccordionContext.Provider>;
}

export const useAccordionState = () => useContext<AccoridionState>(AccordionContext);
